import React, { useEffect, useState } from 'react';
import '../../../styles/admin/AdminTable.css';

const BASE = process.env.REACT_APP_API_URL || '';

function MarketerNoLoginAdCallList({ onSelect, selectedId, interactive = false, refreshToken }) {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');

  const fetchList = async () => {
    setLoading(true); setError('');
    try {
      const url = `${BASE}/api/admin/adcall`;
      const res = await fetch(url, { credentials: 'include' });
      const ct = res.headers.get('content-type') || '';
      let data = null;
      if (ct.includes('application/json')) {
        data = await res.json().catch(() => ({}));
      } else {
        await res.text();
        if (res.status === 401 || res.status === 403) throw new Error('관리자 인증이 필요합니다.');
        throw new Error(`서버 응답 형식 오류(${res.status}).`);
      }
      if (!res.ok || !data?.ok) throw new Error(data?.message || `불러오기 실패(${res.status})`);
      setItems(Array.isArray(data.items) ? data.items : []);
    } catch (e) {
      setError(e.message || '불러오기 실패');
      setItems([]);
    }
    setLoading(false);
  };

  useEffect(() => { fetchList(); }, [refreshToken]);

  const fmt = (ts) => ts ? new Date(ts).toLocaleString() : '';
  const nameOf = (u) => u?.managerName || '이름없음';

  return (
    <div className="admin-list">
      <div className="admin-list__header">광고대행 문의(비로그인)</div>
      
      <div className="admin-list__body admin-list__body--fixed-height">
        {error && <div className="admin-list__error">{error}</div>}
        {loading && <div className="admin-list__loading">불러오는 중...</div>}
        {!loading && items.length === 0 && !error && <div className="admin-list__empty">문의 내역이 없습니다.</div>}
        
        {!loading && items.length > 0 && (
          <div>
            {items.map((u, i) => (
              <div
                key={u._id || i}
                onClick={interactive && onSelect ? () => onSelect(u) : undefined}
                className={`admin-list__item ${
                  selectedId && (selectedId === (u._id || `${nameOf(u)}-${u.createdAt}`)) ? 'admin-list__item--selected' : ''
                }`}
                style={{ cursor: interactive ? 'pointer' : 'default' }}
              >
                <div className="admin-list__item-row">
                  <div className="admin-list__item-main">{nameOf(u)}</div>
                  <div className="admin-list__item-sub">{fmt(u.createdAt)}</div>
                </div>
                <div className="admin-list__item-meta">
                  상태: <span className={`admin-list__item-badge ${u.status === 'done' ? 'admin-list__item-badge--success' : 'admin-list__item-badge--warning'}`}>
                    {u.status === 'done' ? '완료' : '대기'}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default MarketerNoLoginAdCallList;
